import { render, staticRenderFns } from "./IVRSettlementSettings.vue?vue&type=template&id=7ac5aaa2&"
import script from "./IVRSettlementSettings.vue?vue&type=script&lang=js&"
export * from "./IVRSettlementSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports